import React from 'react';
import { SVGProps } from '../../helpers/types';

const CrossGreen: React.FC<SVGProps> = () => {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.66666 1.27334L8.72666 0.333344L5 4.06001L1.27333 0.333344L0.333328 1.27334L4.06 5.00001L0.333328 8.72668L1.27333 9.66668L5 5.94001L8.72666 9.66668L9.66666 8.72668L5.93999 5.00001L9.66666 1.27334Z"
        fill="#12B76A"
      />
    </svg>
  );
};

export default CrossGreen;
